module.exports = __webpack_public_path__ + "img/sweden.275813d2.svg";